import React, { useState, useEffect } from "react";
import { Phone, Menu, X } from "lucide-react";
import WashSofaLogo from "./WashSofaLogo";

const NAV_LINKS = [
  { href: "#hero", label: "Home" },
  { href: "#servizi", label: "Servizi" },
  { href: "#tecnologia", label: "Tecnologia" },
  { href: "#ecosostenibilita", label: "Ecosostenibilità" },
  { href: "#contatti", label: "Contatti" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("hero");

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 10);

      // Update active section based on scroll position
      const sections = NAV_LINKS.map((l) => l.href.replace("#", ""));
      for (let i = sections.length - 1; i >= 0; i--) {
        const el = document.getElementById(sections[i]);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= 100) {
            setActiveSection(sections[i]);
            break;
          }
        }
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNavClick = (e, href) => {
    e.preventDefault();
    setMenuOpen(false);
    const id = href.replace("#", "");
    const el = document.getElementById(id);
    if (el) {
      const offset = 72;
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <nav
      className="navbar"
      style={{
        boxShadow: scrolled
          ? "0 2px 12px rgba(0,0,0,0.12)"
          : "0 1px 4px rgba(0,0,0,0.06)",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "0 1.5rem",
          height: "72px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* Logo */}
        <a
          href="#hero"
          onClick={(e) => handleNavClick(e, "#hero")}
          style={{ textDecoration: "none", flexShrink: 0 }}
        >
          <WashSofaLogo />
        </a>

        {/* Desktop Nav */}
        <div
          className="desktop-nav"
          style={{ display: "flex", alignItems: "center", gap: "0.2rem" }}
        >
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => handleNavClick(e, link.href)}
              className={`nav-link${
                activeSection === link.href.replace("#", "") ? " active" : ""
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        {/* CTA + Hamburger */}
        <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          <a href="tel:+393463785564" className="btn-chiama desktop-cta">
            <Phone size={16} />
            CHIAMA ORA
          </a>

          <button
            className="mobile-menu-btn"
            onClick={() => setMenuOpen(!menuOpen)}
            style={{
              display: "none",
              background: "none",
              border: "none",
              cursor: "pointer",
              padding: "0.4rem",
            }}
            aria-label="Menu"
          >
            {menuOpen ? (
              <X size={24} color="#333" />
            ) : (
              <Menu size={24} color="#333" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Drawer */}
      {menuOpen && (
        <div
          style={{
            background: "white",
            borderTop: "1px solid #eee",
            padding: "1rem 1.5rem",
          }}
        >
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => handleNavClick(e, link.href)}
              className="nav-link"
              style={{
                display: "block",
                padding: "0.8rem 0",
                borderBottom: "1px solid #f0f0f0",
              }}
            >
              {link.label}
            </a>
          ))}
          <a
            href="tel:+393463785564"
            className="btn-chiama"
            style={{ marginTop: "1rem", display: "inline-flex" }}
          >
            <Phone size={16} />
            CHIAMA ORA
          </a>
        </div>
      )}

      <style>{`
        @media (max-width: 900px) {
          .desktop-nav { display: none !important; }
          .desktop-cta { display: none !important; }
          .mobile-menu-btn { display: block !important; }
        }
      `}</style>
    </nav>
  );
}
